import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  height: 90vh;

  .ant-table-thead .ant-table-cell {
    background-color: white;
    color: #8c8c8c;
    font-weight: 600;
  }
`;

export { Container };
